/* eslint semi:0 */
import BaseClass from '../../application/BaseClass'
import EmbedCodeModalVm from '../vms/embedCodeModalVm'
import { make as makeComponent } from '../../utils/component'
import EmbedCodeModalView from '../views/EmbedCodeModalView'
import EmbedCodeModalStore from '../stores/embedCodeModalStore'

class EmbedCodeModalController extends BaseClass {
  constructor(options = {}) {
    super(options)
    options.store = options.store || EmbedCodeModalStore.getInstance()
    this.merge({
      vm: EmbedCodeModalVm.create(options),
      store: options.store,
    })
  }
}

export default makeComponent(EmbedCodeModalController, EmbedCodeModalView)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/embedCodeModalComponent.js